import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';

const FacturasConciliarHeader = ({
    facturasFiltradas,
    facturasSeleccionadas,
    setFacturasSeleccionadas,
    totalFacturasSeleccionadas
}) => {
    return (
        <Row className="align-items-center">
            <Col xs={12} xl="auto" className="text-end d-flex flex-wrap align-items-center justify-content-end gap-3 mt-2 mt-xl-0">
                <div className="d-flex align-items-center gap-3">
                    <small className="text-primary fw-bold">
                        {facturasFiltradas.length} facturas
                    </small>
                </div>
                {facturasSeleccionadas.length > 0 && (
                    <div className="d-flex align-items-center gap-3">
                        <small className="text-primary fw-bold">
                            | {facturasSeleccionadas.length} seleccionada{facturasSeleccionadas.length !== 1 ? 's' : ''} | Total: ${totalFacturasSeleccionadas.toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN |
                        </small>
                        <Button
                            variant="link"
                            className="p-0 text-danger text-decoration-none fs--1"
                            onClick={() => setFacturasSeleccionadas([])}
                        >
                            <i className="fas fa-times me-1"></i>
                            Deseleccionar todas
                        </Button>
                    </div>
                )}
            </Col>
        </Row>
    );
};

FacturasConciliarHeader.propTypes = {
    facturasFiltradas: PropTypes.array,
    facturasSeleccionadas: PropTypes.array,
    setFacturasSeleccionadas: PropTypes.func,
    totalFacturasSeleccionadas: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default FacturasConciliarHeader;
